import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { AddButtonProps } from './types';

export const AddButton = ({ title, ...props }: AddButtonProps) => (
  <div>
    <Button startIcon={<AddIcon />} {...props}>
      Add {title}
    </Button>
  </div>
);
